<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
      </section>

      <section class="list">
        <h3>
          絞り込み条件
          <div class="ctrl-btn opened" @click="switchAccordion"></div>
        </h3>
        <div class="accordion_inner">
          <v-row>
            <v-col cols="6" md="3">
              <v-text-field
                ref="orderNo"
                label="伝票No"
                v-model="filterKeyword.orderNo"
                outlined clearable hide-details="auto">
              </v-text-field>
            </v-col>
            <template v-if="corporateItems.length > 0">
              <v-col cols="6" md="3">
                <v-combobox
                  ref="corporate"
                  label="発行元"
                  v-model="filterKeyword.corporate"
                  :items="corporateItems"
                  append-icon="fas fa-list-ol"
                  @click.stop="openSelected('corporate')"
                  readonly outlined clearable hide-details="auto">
                </v-combobox>
              </v-col>
            </template>
            <v-col cols="6" md="3">
              <v-combobox
                ref="customer"
                label="客先"
                v-model="filterKeyword.customer"
                :items="customers"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('customer')"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" md="3">
              <v-combobox
                ref="agency"
                label="代理店"
                v-model="filterKeyword.agency"
                :items="customers"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('agency')"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" md="3">
              <v-combobox
                ref="sales"
                label="営業担当"
                v-model="filterKeyword.sales"
                :items="users"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('sales')"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" md="3">
              <v-combobox
                ref="payment"
                label="支払方法"
                v-model="filterKeyword.payment"
                :items="payment"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('payment')"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="6" md="3">
              <v-menu
                v-model="estimate_span"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="from"
                    label="見積日"
                    :value="estimateSpanText"
                    v-on="on"
                    @click:clear="filterKeyword.estimate_span = []"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker 
                  v-model="filterKeyword.estimate_span" 
                  :title-date-format="estimateSpanFunc"
                  range></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" md="3">
              <v-menu
                v-model="claim_span"
                :close-on-content-click="false"
                :nudge-right="0"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="to"
                    label="請求日"
                    :value="claimSpanText"
                    v-on="on"
                    @click:clear="filterKeyword.claim_span = []"
                    outlined clearable hide-details="auto">
                  </v-text-field>
                </template>
                <v-date-picker 
                  v-model="filterKeyword.claim_span" 
                  :title-date-format="claimSpanFunc"
                  range></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </div>
        <h3 class="mt-5">検索結果</h3>
        <v-data-table
          :headers="tableHeaders"
          :items="filterItems"
          :sort-by="['id']"
          :sort-desc="[true]"
          :loading="loading"
          @click:row="onRowClick">
          <template v-slot:item.customer="{ item }">
            {{ item.customer.name }}
          </template>
          <template v-slot:item.corporateID="{ item }">
            {{ getCorporateLabel(item.corporateID) }}
          </template>
          <template v-slot:item.amount="{ item }">
            &yen; {{ separate( Math.floor(item.amount * (item.tax / 100 + 1)) ) }}
          </template>
          <template v-slot:item.complete="{ item }">
            <template v-if="item.complete">
              <v-icon color="green darken-2">far fa-check-circle</v-icon>
            </template>
          </template>
          <template v-slot:item.estimateDate="{ item }">
            {{ getDateTime(item.estimateDate, 'YYYY-MM-DD') }}
          </template>
          <template v-slot:item.claimDate="{ item }">
            {{ getDateTime(item.claimDate, 'YYYY-MM-DD') }}
          </template>
        </v-data-table>
        <div class="total">
          <span class="label">合計</span>
          <span class="value">&yen; {{ separate(totalValue) }}</span>
        </div>
      </section>

      <!-- 編集ダイアログ -->
      <Slip
        :editedItem="editedItem"
        :customers="customers"
        :users="users"
        :corporates="corporates"
        :appOptions="appOptions"
        :show="dialog"
        @close="dialog = false" />

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { listOrders, listAppOptions, listCustomers, listUsers, listCorporates } from '../graphql/queries'
import { onCreateOrder, onUpdateOrder, onDeleteOrder } from '../graphql/subscriptions'
import moment from 'moment'
import Slip from '@/components/Slip'

export default {
  data() {
    return {
      search: '',
      loading: true,
      tableHeaders: [
        { text: '伝票No', align: 'start', value: 'id' },
        { text: '件名', align: 'start', value: 'title' },
        { text: '発行元', align: 'start', value: 'corporateID' },
        { text: '客先', align: 'start', value: 'customer' },
        { text: '見積日', align: 'start', value: 'estimateDate' },
        { text: '請求日', align: 'start', value: 'claimDate' },
        //{ text: '支払方法', align: 'start', value: 'payment' },
        //{ text: '支払完了', align: 'start', value: 'complete' },
        { text: '合計金額（税込）', align: 'end', value: 'amount' },
      ],
      dialog: false,
      valid: false,
      saving: false,
      desserts: [],
      customers: [],
      users: [],
      corporates: [],
      appOptions: {},
      editedIndex: -1,
      editedItem: {
        items: [],
      },
      //logoURL: null,
      filterKeyword: {
        estimate_span: [],
        claim_span: [],
      },
      estimate_span: false,
      claim_span: false,
    }
  },
  prop: {},
  mounted: async function() {
    let timer = setInterval(() => {
      if (this.getMyself()) {
        clearInterval(timer)
        this.init();
      }
    }, 100)

    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateOrder)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateOrder
        this.desserts.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateOrder)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateOrder
        this.desserts.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteOrder)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteOrder
        this.desserts = this.desserts.filter(origin => origin.id !== row.id)
      }
    })
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    filterItems() {
      const map = []
      for (const item of this.desserts) {
        //注文No
        if (this.filterKeyword.orderNo && item.id.indexOf(this.filterKeyword.orderNo) < 0) continue
        //発行先
        if (this.filterKeyword.corporate) {
          if (this.corporateItems[0].value == this.filterKeyword.corporate.value) {
            if (item.corporateID && this.filterKeyword.corporate.value != item.corporateID) continue
            
          } else {
            if (this.filterKeyword.corporate.value != item.corporateID) continue
          }
        }
        //if (this.filterKeyword.corporate && this.filterKeyword.corporate.value != item.corporateID) continue
        //客先
        if (this.filterKeyword.customer && this.filterKeyword.customer.value != item.customerID) continue
        //代理店
        if (this.filterKeyword.agency && this.filterKeyword.agency.value != item.agencyID) continue
        //営業担当
        if (this.filterKeyword.sales && this.filterKeyword.sales.value != item.customer.salesID) continue
        //決済方法
        if (this.filterKeyword.payment && this.filterKeyword.payment != item.payment) continue
        //見積日
        if (this.filterKeyword.estimate_span.length > 0) {
          let from = this.filterKeyword.estimate_span[0]
          let to = this.filterKeyword.estimate_span[1] || null
          if (to) {
            if (moment(from) > moment(item.estimateDate) || moment(item.estimateDate) > moment(to)) continue
          } else {
            if (moment(from) > moment(item.estimateDate)) continue
          }
          if (!item.estimateDate) continue
        }
        //請求日
        if (this.filterKeyword.claim_span.length > 0) {
          let from = this.filterKeyword.claim_span[0]
          let to = this.filterKeyword.claim_span[1] || null
          if (to) {
            if (moment(from) > moment(item.claimDate) || moment(item.claimDate) > moment(to)) continue
          } else {
            if (moment(from) > moment(item.claimDate)) continue
          }
          if (!item.claimDate) continue
        }

        map.push(item)
      }
      return map
    },
    totalValue() {
      let sum = 0
      for (const item of this.filterItems) {
        sum += Math.floor(item.amount * (item.tax / 100 + 1))
      }
      return sum
    },
    estimateSpanText() {
      let date = this.filterKeyword.estimate_span ? this.filterKeyword.estimate_span : []
      date.sort(function(a,b) {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      return date.length > 0 ? date.join(' ～ ') : null
    },
    claimSpanText() {
      let date = this.filterKeyword.claim_span ? this.filterKeyword.claim_span : []
      date.sort(function(a,b) {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      return date.length > 0 ? date.join(' ～ ') : null
    },
    corporateItems() {
      const map = []
      for (const item of this.corporates) {
        map.push({
          text: item.name,
          value: item.id
        })
      }
      return map
    },
  },
  watch: {

  },
  methods: {
    //初期化
    async init() {
      //受注リスト query
      await this.getOrders()
      //客先 query
      await this.getCustomers()
      //ユーザー query
      await this.getUsers()
      //企業情報 query
      await this.getCorporates()
      //設定 query
      const appOptionQuery = await API.graphql(graphqlOperation(listAppOptions, { limit: 100 }))
      for (const row of appOptionQuery.data.listAppOptions.items) {
        this.appOptions[row.name] = row.value
      }

      this.loading = false
    },
    //行選択
    async onRowClick(params) {
      try {
        this.editedIndex = this.desserts.findIndex(e => e.id === params.id)

        this.editedItem = Object.assign({
          items: [],
        }, params)

        //客先
        this.editedItem.customerID = this.customers.find(e => e.value == params.customerID)
        this.dialog = true
      } catch (e) {
        console.log(e)
      }
    },
    //アコーディオンの開閉
    switchAccordion(e) {
      const target = e.target.parentElement.nextSibling
      target.style.display = target.style.display == 'none' ? 'block' : 'none'
      e.target.classList.toggle('opened')
    },
    //受注リストの取得
    async getOrders(nextToken = null) {
      //所属企業
      const myself = this.getMyself()
      const corporateFilter = []
      for (const id of myself.corporateIDs) {
        corporateFilter.push({
          corporateID: { eq: id }
        })
      }
      const query = await API.graphql(graphqlOperation(listOrders, { 
        filter: {
          or: corporateFilter
        },
        limit: 500, 
        nextToken: nextToken 
      }))
      for (const row of query.data.listOrders.items) {
        this.desserts.push(row)
      }
      if (query.data.listOrders.nextToken) this.getOrders(query.data.listOrders.nextToken)
    },
    //客先の取得
    async getCustomers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listCustomers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listCustomers.items) {
        this.customers.push({
          value: data.id,
          text: data.name + (data.office ? '（' + data.office + '）' : ''),
          agencyID: data.agencyID || null,
        })
      }
      if (query.data.listCustomers.nextToken) this.getCustomers(query.data.listCustomers.nextToken)
    },
    //ユーザーの取得
    async getUsers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listUsers, { limit: 500, nextToken: nextToken }))
      for (const data of query.data.listUsers.items) {
        this.users.push({
          value: data.id,
          text: data.last + data.first,
          corporateIDs: data.corporateIDs,
        })
      }
      if (query.data.listUsers.nextToken) this.getUsers(query.data.listUsers.nextToken)
    },
    //企業の取得
    async getCorporates(nextToken = null) {
      //所属企業
      const myself = this.getMyself()
      const corporateFilter = []
      for (const id of myself.corporateIDs) {
        corporateFilter.push({
          id: { eq: id }
        })
      }
      const query = await API.graphql(graphqlOperation(listCorporates, { 
        filter: {
          or: corporateFilter
        },
        limit: 500, 
        nextToken: nextToken 
      }))
      for (const data of query.data.listCorporates.items) {
        this.corporates.push(data)
      }
      if (query.data.listCorporates.nextToken) this.getCorporates(query.data.listCorporates.nextToken)
    },
    //見積選択日付表示
    estimateSpanFunc() {
      return this.estimateSpanText || ''
    },
    //請求選択日付表示
    claimSpanFunc() {
      return this.claimSpanText || ''
    },
    //企業
    getCorporateLabel(id) {
      const corporate = this.corporateItems.find(e => e.value === id)
      return corporate ? corporate.text : null
    },
  },
  components: {
    Slip,
  },
}
</script>

<style lang='scss' scoped>
.list {
  .total {
    text-align: right;
    font-size: 20px;
    .label {
      padding: 10px;
    }
    .value {
      display: inline-block;
      background: #EEE;
      padding: 10px;
      width: 200px;
    }
  }
}
</style>
